export default {
    cover: {
        text: 'Найдите свои услуги здесь',
        button: 'ИССЛЕДОВАТЬ ЗДЕСЬ',
        no_offers: 'В настоящее время нет услуг для этой категории',
        show_all: 'Показать все',
    },
    widget: {
        book_experience: 'Забронируйте свой опыт',
        top_companies: 'Лучшие компании',
        find_offers: 'Найти услуги',
    },
    subdomain: {
        popular_offer: 'Самые популярные услуги',
        show_more: 'Показать все',
    },
}
